import AssetRiskScoreDialog from './AssetRiskScoreDialog';

export default AssetRiskScoreDialog;
export { AssetRiskScoreDialog };
